import React from 'react';
import {
  EInterviewFinalResult,
  EEmploymentType,
  EInterviewProgress,
  EInterviewAtmosphere,
  EInterviewDificultyLevel,
} from 'enums/community.enum';

export const CInterviewFinalResult: { [key: string]: string } = {
  [EInterviewFinalResult.Pass]: '합격',
  [EInterviewFinalResult.Proceeding]: '진행중',
  [EInterviewFinalResult.Fail]: '불합격',
};

export const CEmploymentType: { [key: string]: string } = {
  [EEmploymentType.Newcomer]: '신입',
  [EEmploymentType.ExperiencedWorker]: '경력',
  [EEmploymentType.TransitionalTypeIntern]: '전환형 인턴',
  [EEmploymentType.GeneralTypeIntern]: '일반 인턴(RA)',
};

export const CInterviewProgress: { [key: string]: string } = {
  [EInterviewProgress.FaceToFace]: '대면',
  [EInterviewProgress.Zoom]: 'Zoom',
  [EInterviewProgress.Call]: '전화',
};

export const CInterviewAtmosphere: { [key: string]: string } = {
  [EInterviewAtmosphere.Comfortable]: '편안',
  [EInterviewAtmosphere.Normal]: '보통',
  [EInterviewAtmosphere.Uncomfortable]: '경직',
};

export const CInterviewDificultyLevel: { [key: string]: string } = {
  [EInterviewDificultyLevel.Easy]: '쉬움',
  [EInterviewDificultyLevel.Normal]: '보통',
  [EInterviewDificultyLevel.Difficulty]: '어려움',
};

export const CInterviewRoundText: { [key: string]: string } = {
  '1': '1st',
  '2': '2nd',
  '3': '3rd',
  '4': '4th',
  '5': '5th',
  '6': '6th',
  '7': '7th',
};
